module.exports = __webpack_public_path__ + "img/campanas-de-vidrio.535102e4.png";